import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import SettingsContent from './SettingsContent'

export default class Settings extends Component {

    render() {
        

        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <SettingsContent />
                <Footer />

            </div>


        )
    }
}
